import React from 'react';
import { StyledHeaderContainer, StyledPaperContainer } from '../../PlusWebsiteEditor/PlusWebsiteEditor.styles';
import useVirtualMedicineForm from '../hooks/useVirtualMedicineForm';
import { VirtualMedicine as IVirtualMedicine } from '../../../apis/virtual-medicines/types';
import { VirtualMedicineFooter } from './VirtualMedicineFooter';
import { ColumnWithGap } from '../../PlusWebsiteEditor/sections/HeroBlock/HeroBlock.styled';
import VirtualMedicineSizeEditor from './Editors/VirtualMedicineNameEditor';
import MasterMedicineSelectorEditor from '../../FormEditors/MasterMedicineSelectorEditor';
import VirtualMedicineFormEditor from './Editors/VirtualMedicineFormEditor';
import VirtualMedicineStrengthEditor from './Editors/VirtualMedicineStrengthEditor';

interface VirtualMedicineProps {
  virtualMedicine?: IVirtualMedicine | null;
  masterMedicineId?: string;
}

const VirtualMedicine = ({ masterMedicineId, virtualMedicine }: VirtualMedicineProps) => {
  const form = useVirtualMedicineForm({ master_medicine_id: masterMedicineId, ...virtualMedicine });

  return (
    <ColumnWithGap>
      <StyledHeaderContainer />
      <StyledPaperContainer>
        <ColumnWithGap>
          <MasterMedicineSelectorEditor control={form.control} name="master_medicine_id" />
          <VirtualMedicineFormEditor form={form} />
          <VirtualMedicineSizeEditor form={form} />
          <VirtualMedicineStrengthEditor form={form} />
        </ColumnWithGap>
      </StyledPaperContainer>
      <VirtualMedicineFooter id={virtualMedicine?._id} form={form} />
    </ColumnWithGap>
  );
};

export default VirtualMedicine;
